import { useTheme } from 'hooks/useTheme';
import { useEffect } from 'react';
import { THEME_TYPE } from 'store/theme';
import { IChildrenProp } from 'types/components/components.interface';

const ThemeProvider = ({ children }: IChildrenProp) => {
  const { theme, themeType } = useTheme();

  const defaultTheme = {
    id: 'default',
    name: 'Default',
    primary: '#4f90ff',
    text: '#162032',
    background: '#f2f3f5',
    appBackground: '#dce1e8',
    secondarySoft: '#d8deea',
    secondaryLight: '#919bad',
    secondary: '#5b6575',
    darkPrimary: '#4f90ff',
    darkText: '#e4e4f2',
    darkBackground: '#242c37',
    darkAppBackground: '#191d23',
    darkSecondarySoft: '#626a77',
    darkSecondaryLight: '#8b93a1',
    darkSecondary: '#647084',
    isPredefined: true,
    isActive: true,
  };

  //   const defaultTheme = {
  //     id: "5f34a1b0-d1f1-47f7-a262-4d645c154487",
  //     name: "LUMO",
  //     primary: "#f23c74",
  //     text: "#ffffff",
  //     background: "#161515",
  //     appBackground: "#000000",
  //     secondarySoft: "#5e585b",
  //     secondaryLight: "#6f696a",
  //     secondary: "#b2a6a9",
  //     darkPrimary: "#f23c74",
  //     darkText: "#ffffff",
  //     darkBackground: "#161515",
  //     darkAppBackground: "#000000",
  //     darkSecondarySoft: "#5e585b",
  //     darkSecondaryLight: "#6f696a",
  //     darkSecondary: "#b2a6a9",
  //     isActive: true,
  //     isPredefined: false,
  //     canChangeThemeMode: true,
  //     defaultThemeMode: 2,
  //     printTheme: {
  //       removeTableBoarders: false,
  //       addDocumentHeader: false,
  //       showLogo: false,
  //       headerBackgroudColor: null,
  //       headerFontColor: null,
  //       fontColor: null,
  //       summaryBackgroudColor: null,
  //       summaryFontColor: null,
  //     },
  //   };

  const setPropertyColor = (property: string, light: string, dark: string) => {
    const color =
      themeType === null
        ? theme?.defaultThemeMode === THEME_TYPE.light
          ? light
          : dark
        : themeType === THEME_TYPE.light
          ? light
          : dark;
    document.documentElement.style.setProperty(`--${property}`, color);
  };

  useEffect(() => {
    // if (!theme) return;

    setPropertyColor(
      'primary',
      theme?.primary ?? defaultTheme.primary,
      theme?.darkPrimary ?? defaultTheme.darkPrimary,
    );
    setPropertyColor(
      'text',
      theme?.text ?? defaultTheme.text,
      theme?.darkText ?? defaultTheme.darkText,
    );
    setPropertyColor(
      'background',
      theme?.background ?? defaultTheme.background,
      theme?.darkBackground ?? defaultTheme.darkBackground,
    );
    setPropertyColor(
      'app-background',
      theme?.appBackground ?? defaultTheme.appBackground,
      theme?.darkAppBackground ?? defaultTheme.darkAppBackground,
    );
    setPropertyColor(
      'secondary',
      theme?.secondary ?? defaultTheme.secondary,
      theme?.darkSecondary ?? defaultTheme.darkSecondary,
    );
    setPropertyColor(
      'secondary-soft',
      theme?.secondarySoft ?? defaultTheme.secondarySoft,
      theme?.darkSecondarySoft ?? defaultTheme.darkSecondarySoft,
    );
    setPropertyColor(
      'secondary-light',
      theme?.secondaryLight ?? defaultTheme.secondaryLight,
      theme?.darkSecondaryLight ?? defaultTheme.darkSecondaryLight,
    );

    const root = document.documentElement;
    const themeClass =
      themeType === null || themeType === THEME_TYPE.light ? 'light-mode-theme' : 'dark-mode-theme';

    root.classList.remove('light-mode-theme', 'dark-mode-theme');
    root.classList.add(themeClass);
  }, [theme, themeType]);

  return <>{children}</>;
};

export default ThemeProvider;
